import {
  XCircle,
  Baby,
  PawPrint,
  Cigarette,
  CreditCard,
  type LucideIcon,
} from 'lucide-react'

const POLICY_CONFIG: Array<{ key: string; label_en: string; label_ar: string; icon: LucideIcon }> = [
  { key: 'cancellation', label_en: 'Cancellation', label_ar: 'سياسة الإلغاء', icon: XCircle },
  { key: 'children', label_en: 'Children', label_ar: 'الأطفال', icon: Baby },
  { key: 'pets', label_en: 'Pets', label_ar: 'الحيوانات الأليفة', icon: PawPrint },
  { key: 'smoking', label_en: 'Smoking', label_ar: 'التدخين', icon: Cigarette },
  { key: 'payment', label_en: 'Payment', label_ar: 'الدفع', icon: CreditCard },
]

interface PropertyPoliciesProps {
  policies: Record<string, { en?: string; ar?: string }> | null
  locale: string
}

export function PropertyPolicies({ policies, locale }: PropertyPoliciesProps) {
  if (!policies || Object.keys(policies).length === 0) return null

  const isRtl = locale === 'ar'

  const visiblePolicies = POLICY_CONFIG.filter((p) => {
    const val = policies[p.key]
    return val && (val.en || val.ar)
  })

  if (visiblePolicies.length === 0) return null

  return (
    <section>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        {isRtl ? 'السياسات' : 'Policies'}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {visiblePolicies.map((config) => {
          const Icon = config.icon
          const val = policies[config.key]
          const text = isRtl ? (val?.ar || val?.en) : (val?.en || val?.ar)

          return (
            <div key={config.key} className="flex gap-3 p-3 rounded-lg bg-white dark:bg-gray-800/50 border border-gray-100 dark:border-gray-700/50">
              <Icon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
              <div>
                <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {isRtl ? config.label_ar : config.label_en}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5 leading-relaxed">
                  {text}
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
